const overseasPrivacyTermsRouter = {
  title: '隐私条款管理',
  type: 'view',
  name: 'overseasPrivacyTerms',
  route: '/overseas-privacy-terms/config',
  filePath: 'view/overseas_privacy_terms/index.vue',
  order: 10,
  inNav: true,
  icon: 'iconfont el-icon-document',
  permission: ['查询隐私条款'],
}

export default overseasPrivacyTermsRouter
